import { CHANNELS } from './channels';

// Paleta categórica validada: en este orden, cada color se distingue de su
// vecino (aqua, amarillo y magenta quedan por debajo de 3:1 sobre blanco, por
// eso el reparto lleva tabla de detalle).
const BLUE = '#2a78d6';
const ORANGE = '#eb6834';
const AQUA = '#1baf7a';
const YELLOW = '#eda100';
const MAGENTA = '#e87ba4';
const GREEN = '#008300';
const VIOLET = '#4a3aa7';
const RED = '#e34948';
export const NEUTRAL_COLOR = '#c4c3bd';

// Hay más canales que colores distinguibles: tras los 8 lisos se repite la
// paleta en el mismo orden con rayas y luego con puntos, así cada franja se
// distingue de sus vecinas por color y de su gemela por textura.
export type ChannelFill = 'solid' | 'hatched' | 'dotted';

export type ChannelStyle = { name: string; color: string; fill: ChannelFill };

// Orden de apilado en la barra: fijo, para que las franjas vecinas nunca
// compartan color.
export const CHANNEL_STYLES: ChannelStyle[] = [
  { name: 'Direct', color: BLUE, fill: 'solid' },
  { name: 'Paid Social', color: ORANGE, fill: 'solid' },
  { name: 'Organic Search', color: AQUA, fill: 'solid' },
  { name: 'Paid Search', color: YELLOW, fill: 'solid' },
  { name: 'Referral', color: MAGENTA, fill: 'solid' },
  { name: 'Organic Social', color: GREEN, fill: 'solid' },
  { name: 'Email', color: VIOLET, fill: 'solid' },
  { name: 'Partnerships', color: RED, fill: 'solid' },
  { name: 'IA', color: BLUE, fill: 'hatched' },
  { name: 'Cross-network', color: ORANGE, fill: 'hatched' },
  { name: 'Paid Shopping', color: AQUA, fill: 'hatched' },
  { name: 'Paid Video', color: YELLOW, fill: 'hatched' },
  { name: 'Display', color: MAGENTA, fill: 'hatched' },
  { name: 'Press', color: GREEN, fill: 'hatched' },
  { name: 'WhatsApp', color: VIOLET, fill: 'hatched' },
  { name: 'Offline', color: RED, fill: 'hatched' },
  { name: 'Influencers', color: BLUE, fill: 'dotted' },
  { name: 'Sales', color: ORANGE, fill: 'dotted' },
  { name: 'ATC', color: AQUA, fill: 'dotted' },
  { name: 'Otro', color: NEUTRAL_COLOR, fill: 'solid' },
];

// Canal sin estilo propio (p.ej. uno nuevo en CHANNELS): neutro, al final.
export const DEFAULT_CHANNEL_STYLE: Omit<ChannelStyle, 'name'> = {
  color: NEUTRAL_COLOR,
  fill: 'dotted',
};

// Otro no se pide con su filtro: en el reparto es, por definición, el total
// menos la suma del resto de canales.
export const OTHER_CHANNEL_NAME = 'Otro';

// Parte aún sin repartir mientras llegan los canales: más clara que el neutro.
export const PENDING_COLOR = '#ebeae6';

// Orden de petición, el que marca MKT para que lo que más le importa llegue
// antes. Distinto del de apilado, que manda CHANNEL_STYLES.
const CHANNEL_REQUEST_ORDER = [
  'Organic Search',
  'Paid Search',
  'Cross-network',
  'Paid Social',
  'Organic Social',
  'Direct',
  'IA',
  'Email',
  'Influencers',
  'Referral',
  'Partnerships',
  'Press',
  'Display',
  'Offline',
];

// Canales que se piden, en orden: los de CHANNEL_REQUEST_ORDER y después el
// resto en el orden del selector, todos menos Otro.
export const MIX_CHANNEL_DEFINITIONS = [
  ...CHANNEL_REQUEST_ORDER.flatMap((name) =>
    CHANNELS.filter((c) => c.name === name)
  ),
  ...CHANNELS.filter(
    (c) =>
      !CHANNEL_REQUEST_ORDER.includes(c.name) && c.name !== OTHER_CHANNEL_NAME
  ),
];

// Posición de un canal en la barra; los que no tienen estilo, al final.
export function stackIndex(name: string): number {
  const index = CHANNEL_STYLES.findIndex((s) => s.name === name);
  return index === -1 ? CHANNEL_STYLES.length : index;
}
